import Navbar from "../components/Navbar"
import CameraPanel from "../components/CameraPanel"
import Footer from "../components/Footer"

export default function LiveDetection(){

return(

<div className="app-shell">

<Navbar/>

<section className="page-section">
<div className="section-shell px-6 text-center">
<div className="eyebrow">Live Inference</div>
<h1 className="mt-6 text-4xl text-stone-900 md:text-6xl">

Live Sign Language Detection

</h1>
<p className="mx-auto mt-5 max-w-2xl text-lg leading-8 text-stone-600">
Start the webcam, capture a frame, and inspect the current predicted letter plus the assembled output stream.
</p>
</div>
</section>

<CameraPanel/>

<Footer/>

</div>

)

}
